<template>
  <div class="container form_questionner">
    <div class="field">
      <div class="control has-text-centered">
        <div
          class="control"
          v-bind:class="{ 'is-loading': this.checkingUrlParticipant }"
        >
          <b-input
            size="is-small"
            v-model="question"
            name="QUESTION"
            :value="{ question }"
            maxlength="400"
            :placeholder="$t('public.poser_question')"
            type="textarea"
            v-bind="{ disabled: this.checkingUrlParticipant }"
          ></b-input>

          <b-upload
            style="font-size:12px;cursor:pointer;"
            accept="image/png,image/gif,image/jpeg,video/mp4"
            v-model="file"
            :input="checkFileSize()"
            v-bind:class="{ 'is-hidden': !this.question }"
          >
            <span v-if="!file">
              <img
                style="width:15px;"
                src="@/assets/img/icons/add_photo.png"
                alt="create-icon"
              />
              {{ $t('public.illustrer_question') }}
            </span>
          </b-upload>

          <div v-if="file" style="font-size:12px;">
            <!-- <b-icon
                    pack="fas"
                    icon="check-square"
                    size="is-small"
                  ></b-icon>
                  {{ $t("public.illustrer_ok") }} -->
            <span style="position:relative;" @click="removeFile">
              <img style="height:80px;" :src="urlFile" />
              <b-icon
                style="position:absolute;cursor:pointer;right:0;background:white"
                pack="fas"
                icon="trash-alt"
                size="is-small"
              ></b-icon>
            </span>
          </div>

          <div class="control has-text-right">
            <button
              class="button is-primary"
              @click="postQuestion"
              v-bind="[
                { disabled: this.checkingUrlParticipant },
                { disabled: !this.question }
              ]"
              v-bind:class="[{ 'is-loading': this.sendingData }]"
            >
              {{ $t('button.envoyer') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      question: '',
      sendingData: false,
      file: null
    }
  },
  props: {
    checkingUrlParticipant: Boolean,
    meetingId: Number & String,
    urlParticipant: String
  },
  computed: {
    // a computed getter
    urlFile: function () {
      return URL.createObjectURL(this.file)
    }
  },
  methods: {
    displayToastSuccess () {
      this.$buefy.toast.open({
        duration: 3000,
        message: this.$i18n.t('public.envoiOK'),
        type: 'is-primary',
        style:"color:white"
      })
    },
    postQuestion () {
      const form_values = new FormData()
      form_values.append('mediaURL', this.file)
      form_values.append('question', this.question)

      this.sendingData = 'true'
      axios.defaults.headers.common['urlparticipant'] = this.urlParticipant
      axios
        .post(
          process.env.URL_SSO_API + 'textit/public/meeting/' + this.meetingId,
          form_values
        )
        .then(response => {
          this.sendingData = false
          this.question = ''
          this.file = null
          let message = {
            height: document.body.scrollHeight,
            width: document.body.scrollWidth
          }
          window.top.postMessage(message, '*')
          this.displayToastSuccess()
        })
        .catch(error => {
          this.sendingData = false
        })
    },

    removeFile () {
      this.file = null
    },

    checkFileSize () {
      if (this.file && this.file.size > 6000000) {
        this.file = null

        this.$buefy.toast.open({
          type: 'is-danger',
          message: this.$i18n.t('toast.fichier_trop_lourd')
        })
      }
    }
  }
}
</script>

<style>
.form_questionner {
  padding-top:20px !important;
  opacity: 0.95;
  max-width: 500px;
  width: 100%;
  background: white;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
}

.backwhite {
  background: white;
  padding: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
}

.file_upload {
  width: 100%;
}

.button {
  font-size: 12px;
  color:white;
}
.button:hover {
  font-size: 12px;
  color:white;
}
.textarea:not([rows]) {
    max-height: 600px;
    min-height: 120px;
    resize: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Questionner/formQuestionner.vue